import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function PrivateRoute({ children }) {
  const { currentUser, userProfile, loading } = useAuth();
  const location = useLocation();

  // Still loading auth state - show loading
  if (loading) {
    return <div className="flex items-center justify-center min-h-screen">
      <div className="text-gray-600">Loading...</div>
    </div>;
  }

  // Not logged in - redirect to login
  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  // Logged in but no profile exists - redirect to onboarding to create one
  if (!userProfile && location.pathname !== '/onboarding') {
    return <Navigate to="/onboarding" />;
  }

  // Logged in but hasn't completed onboarding - redirect to onboarding
  // UNLESS they're already on the onboarding page
  if (userProfile && !userProfile.onboardingCompleted && location.pathname !== '/onboarding') {
    return <Navigate to="/onboarding" />;
  }

  // All good - render the protected component
  return children;
} 